{
  "name": "@scalar/cli",
  "description": "A command-line interface to work with OpenAPI files",
  "keywords": [
    "scalar",
    "openapi",
    "swagger",
    "cli"
  ],
  "version": "1.0.0",
  "author": "Copyright API Documentation Inc. 2025",
  "license": "UNLICENSED",
  "private": true,
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "@scalar/cli": "vite-node src/index.ts",
    "build": "vite-node esbuild.ts && pnpm copy:static",
    "cli:link": "pnpm run build && npm unlink -g @scalar/cli && npm link",
    "copy:static": "cp -r ../../packages/guide-preview/dist/client ./dist/client",
    "generate:docs": "vite-node scripts/generate-documentation.ts",
    "screenshot": "./scripts/take-screenshots.sh",
    "test:integration": "cp .env.example .env && NODE_ENV=INTEGRATION dotenv -o -- vitest --config test/vitest.config.ts test/**",
    "test:unit": "vitest --config vite.config.ts src/**/*",
    "types:check": "scalar-types-check"
  },
  "type": "module",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    }
  },
  "homepage": "https://github.com/scalar/scalar",
  "bugs": "https://github.com/scalar/scalar/issues/new/choose",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/scalar/scalar.git",
    "directory": "projects/cli"
  },
  "bin": {
    "scalar": "./dist/index.js"
  },
  "dependencies": {
    "@clack/prompts": "catalog:*",
    "@fastify/static": "catalog:*",
    "@hono/node-server": "catalog:*",
    "@scalar-org/entities": "workspace:*",
    "@scalar-org/guide-preview": "workspace:*",
    "@scalar-org/helpers": "workspace:*",
    "@scalar-org/library": "workspace:*",
    "@scalar-org/mongobase-client": "workspace:*",
    "@scalar-org/scalar-config": "workspace:*",
    "@scalar-org/service-api": "workspace:*",
    "@scalar-org/tokens": "workspace:*",
    "@scalar/api-reference": "catalog:scalar",
    "@scalar/mock-server": "catalog:scalar",
    "@scalar/oas-utils": "catalog:scalar",
    "@scalar/openapi-parser": "catalog:scalar",
    "@scalar/openapi-types": "catalog:scalar",
    "@scalar/void-server": "catalog:scalar",
    "@stoplight/spectral-core": "catalog:*",
    "@stoplight/spectral-ruleset-bundler": "catalog:*",
    "@stoplight/spectral-rulesets": "catalog:*",
    "ansis": "catalog:*",
    "chokidar": "catalog:*",
    "commander": "catalog:*",
    "fastify": "catalog:*",
    "get-port": "catalog:*",
    "hono": "catalog:*",
    "jsonc-parser": "catalog:*",
    "nanoid": "catalog:*",
    "prettyjson": "catalog:*",
    "stdout-update": "catalog:*",
    "tailwindcss": "catalog:*"
  },
  "devDependencies": {
    "@scalar-org/api-framework": "workspace:*",
    "@scalar-org/esbuild": "workspace:*",
    "@scalar-org/mongobase": "workspace:*",
    "@scalar-org/random-slug": "workspace:*",
    "@scalar/build-tooling": "catalog:scalar",
    "@types/node": "catalog:*",
    "@types/prettyjson": "catalog:*",
    "strip-ansi": "catalog:*"
  }
}
